// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__Q-F8i","title":"InfoRow_title__3C1FN"};